/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* A Vikimap service module to use for a Vikimap driven application. Supports Accedo One, JSON and Middleware services. (@accedo/vdkweb-vikimap) 4.0.8
* 
*******************************************************************************/
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = function _default(message) {
  var logger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : console;
  if (typeof process === 'undefined') {
    return;
  }
  if (process && process.env && process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line no-unused-expressions
    logger && logger.warn && logger.warn("[@accedo/vdkweb-vikimap][deprecation warning]: ".concat(message));
  }
};
exports["default"] = _default;